export const stepNumbers = {
  constructionTypes: 0,
  systemFilter: 1,
  constructionParams: 2,
  result: 3
}
